import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const resolveUrl = (u) => (!u ? u : u.startsWith("http") ? u : `${BACKEND_URL}${u}`);

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_just-peptides-shop/artifacts/prg6wf25_Image%203%20Trans.png";
export const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/a68a1f7d-1fd6-4905-8c49-2fdbe525ac1a/images/a9900bf7f6bacfcc28ac01b3a85409fa2bcc4611dd735c9e77cd3439968f3a42.png";
export const VIAL_IMG =
  "https://static.prod-images.emergentagent.com/jobs/a68a1f7d-1fd6-4905-8c49-2fdbe525ac1a/images/df2209cfea5204ee29464d67b084f8197d754488deb4f7e5fe03cf97830614e0.png";
export const CATALOG_BANNER =
  "https://static.prod-images.emergentagent.com/jobs/a68a1f7d-1fd6-4905-8c49-2fdbe525ac1a/images/b99cdfac5ee653e519e2ea5c21671e44e42a8d7e3f2054b4a8057a65b23af68d.png";

export const MANUAL_PAYMENT = {
  zelle: "(727) 434-3122",
  venmo: "@Just-Peptides",
  cashapp: "$jsap03 - JP SUPPLY",
  email: "info@justpeptidessupply.com",
  note: "Tracking number and confirmation will be emailed upon payment. Orders are shipped next day if received after 5:00pm (EST).",
  instagram: "DM us on Instagram for a quick response if you run into any issues.",
};
